/* scripts from valamar.com */

class PatronChat {
  constructor() {
    this.init = this.init.bind(this);
  }

  init() {
    let chatButton = document.querySelector('.open-chat-button');
    let icPatronChat = this.setPatronChat();
    let pocValue = 'dd4ad501-b007-4295-9b8e-bcb0f8d6bd23';

    if (CampingAdriaticGlobals['lang'] === 'hr') {
      pocValue = 'eb4e763e-e098-42ad-a826-8c4d021332b0';
    } else if (CampingAdriaticGlobals['lang'] === 'de') {
      pocValue = '8c30706e-233c-4515-853a-8927435f5f4e';
    } else if (CampingAdriaticGlobals['lang'] === 'it') {
      pocValue = '96c9e6f2-1948-460c-a87e-8197b15b1058';
    }

    if (chatButton) {
      chatButton.addEventListener('click', () => {
        icPatronChat.setStateWindowToggle();
      });
    }

    function showBadge(i) {
      let divBadge = document.getElementById("divBadge");

      if (i > 0) {
        divBadge.innerHTML = i;
        divBadge.style.display = "block";
        divBadge.classList.add('badge2');
      } else if (i == 0 && divBadge) {
        divBadge.style.display = "none";
      }
    }

    let currentGuestURL = window.location.href;
    
    icPatronChat.init(
      {
        serverHost: 'https://home-e34.niceincontact.com',
        bus_no: 4603147,
        poc: pocValue,
        params: ['FirstName', 'Last Name', 'first.last@company.com', currentGuestURL],
        customChatButton: true
      }, showBadge
    );

    window.addEventListener('load', (event) => {
      const chat = document.querySelector('#chat-div-wrap');
      const body = document.querySelector('body');
      const batun = document.querySelector('.open-chat-button');
      const observer = new ResizeObserver(entries => {
        const boxElement = entries[0];
        const isSmall = boxElement.contentRect.width <= 0;
        const mvp = document.querySelector('meta[name="viewport"]');
        
        if (isSmall) {
          body.classList.remove('open-chat');
          if (batun) {
            batun.classList.remove('minimize');
          }
          mvp.setAttribute('content','width=device-width, initial-scale=1');
        } else {
          body.classList.add('open-chat');
          if (batun) {
            batun.classList.add('minimize');
          }
          mvp.setAttribute('content','width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
        }
      });

      observer.observe(chat);
    });
  }

  setPatronChat() {
    let initialH = 0;
    let initialW = 0;
    let chatButtonH = 80;
    let chatButtonW = 180;
    let minH = 0;
    let minW = 0;
    let chatH = 750;
    let chatW = 380;
    let _frame = null;
    let _chatButtonFrame = null;
    let _host = null;
    let isIpad = false;
    let popOutChat;
    let CHILD_WINDOW_HANDLE = null;
    let _url = "";
    let win;
    let showBadge;
    let customChatButton = false;
    let xMax;
    let yMax;
    let minHeight = 400;
    let minWidth = 380;
    let customWidth = null;
    let customHeight = null;
    let windowConfig = null;
    let browserScrollWidth = 21;
    let windowScrollWidth = 17;
    let leftPos;
    let topPos;
    let sessionParameter = [];

    function resizeChat(frame, h, w) {
      if (frame) {
        frame.height = h;
        frame.width = w;
      }
    }

    function addCss(position) {
      let css = ".ie-div-position-customer-chat {display: block;} .chat-iframe-wrap {border-radius: 5px 5px 0 0;z-index: 2147483000;position: fixed;bottom: 100px;width: 380px;min-height: 300px;border-radius: 8px;overflow: hidden;opacity: 1;height: calc(100% - 130px);box-shadow: 0 -5px 50px rgba(0, 0, 0, .2);" + position + ": 24px;} .ie-iframe-fixed-customer-chat {background: transparent; border: none; height: 100%;} .ie-iframe-absolute-customer-chat {background: transparent; border: none; top: 0px; float:none; margin: 0px; padding: 0px; position: relative;" + position + ": 24px;} .iframe-shadow {border-radius: 5px 5px 0 0;box-shadow: 0 -5px 50px rgba(0, 0, 0, .2);}";
      let head = document.head || document.getElementsByTagName("head")[0];
      let style = document.createElement("style");
      css = css + ".button-iframe-wrap {bottom: 0px; position: fixed; height: 10%; display: block; z-index: 2147483638;} .ie-chat-button-iframe-fixed-customer-chat {background: transparent; border: none; bottom: 24px; position: fixed;" + position + ": 24px; outline: none} .ie-chat-button-iframe-absolute-customer-chat {background: transparent; border: none; top: 0px; float:none; margin: 0px; padding: 0px; position: relative;" + position + ": 24px;}";
      style.type = "text/css";
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
      head.appendChild(style);
    }

    function addChatIframe(url, host) {
      let d;
      let d1;
      let d2;
      d = document.createElement("div");
      d1 = document.createElement("div");
      d2 = document.createElement("div");
      d.className = "ie-div-position-customer-chat";
      _frame = document.createElement("iframe");
      _frame.src = url;
      _frame.allowtransparency = "true";
      _frame.frameborder = "0px";
      _frame.id = "icChat";
      _frame.name = "icChat";
      _frame.scrolling = "no";
      _frame.style.borderStyle = "none";
      _frame.className = "ie-iframe-fixed-customer-chat";
      d1.id = "chat-div-wrap";
      d1.className = "chat-iframe-wrap";
      d1.appendChild(_frame);
      _chatButtonFrame = document.createElement("iframe");
      _chatButtonFrame.src = host + "/inContact/ChatClient/chatButton.html";
      _chatButtonFrame.allowtransparency = "true";
      _chatButtonFrame.frameborder = "0px";
      _chatButtonFrame.id = "icChatButton";
      _chatButtonFrame.name = "icChatButton";
      _chatButtonFrame.scrolling = "no";
      _chatButtonFrame.height = chatButtonH;
      _chatButtonFrame.width = chatButtonW;
      _chatButtonFrame.style.borderStyle = "none";
      _chatButtonFrame.className = "ie-chat-button-iframe-fixed-customer-chat";
      d2.className = "button-iframe-wrap";
      d2.appendChild(_chatButtonFrame);
      d.appendChild(d1);
      d.appendChild(d2);
      document.body.appendChild(d);
    }

    function isMobileBrowser() {
      let isMobile = false;
      if (/Android/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
        isMobile = true;
      } else if (/iPhone/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
        isMobile = true;
      } else if (/BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
        isMobile = true;
      } else if (/webOS/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
        isMobile = true;
      } else if (/IEMobile/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
        isMobile = true;
      } else if (/Opera Mini/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
        isMobile = true;
      } else {
        isMobile = false;
      }
      //return isMobile
      return false;
    }

    function onMessageReceived(event) {
      let mt;
      let md;
      let popInChat;
      let ispopOutChat = sessionStorage.getItem("isPopOut") && sessionStorage.getItem("isPopOut") !== "true" ? false : true;
      let position;
      try {
        if (event.origin === _host) {
          mt = event.data.messageType;
          md = event.data.data;
          switch (mt) {
            case "resize":
              if (md.minimize === true) {
                resizeChat(_frame, minH, minW);
                _frame.classList.remove("iframe-shadow");
                document.getElementById("chat-div-wrap").style.width = "0"
              } else {
                if (customChatButton === true) {
                  if (customHeight && customWidth !== null) {
                    resizeChat(_frame, customHeight, customWidth)
                  } else {
                    resizeChat(_frame, chatH, chatW)
                  }
                  _frame.classList.add("iframe-shadow");
                  document.getElementById("chat-div-wrap").style.height = customHeight + "px";
                  document.getElementById("chat-div-wrap").style.width = customWidth + "px"
                } else {
                  resizeChat(_frame, chatH, chatW);
                  _frame.classList.add("iframe-shadow");
                  document.getElementById("chat-div-wrap").style.width = chatW + "px"
                }
              }
              if (customChatButton === false) {
                _chatButtonFrame.contentWindow.postMessage({
                  messageType: "resize",
                  data: md,
                }, "*");
              }
              break;
            case "isPopOut":
              resizeChat(_frame, initialH, initialW);
              CHILD_WINDOW_HANDLE = window.open(_host + "/inContact/ChatClient/index.html", "popOutWindow", "width=380,height=600,left=200,top=100");
              sessionStorage.setItem("isChatProfileCalled", "true");
              sessionStorage.setItem("isPopOut", "true");
              popOutChat = {
                messageType: "isPopOut",
                data: md,
              };
              if (customChatButton === false) {
                _chatButtonFrame.contentWindow.postMessage({
                  messageType: "isPopOut",
                  data: {
                    isPopOut: true,
                  },
                }, "*");
              }
              document.getElementById("chat-div-wrap").style.width = "0";
              break;
            case "isPopIn":
              sessionStorage.setItem("isPopOut", "false");
              popInChat = {
                messageType: "isPopIn",
                data: md,
              };
              _frame.contentWindow.postMessage(popInChat, "*");
              if (customChatButton === false) {
                _chatButtonFrame.contentWindow.postMessage({
                  messageType: "isPopIn",
                  data: {
                    isPopIn: true,
                  },
                }, "*");
              }
              break;
            case "getStoreData":
              if (CHILD_WINDOW_HANDLE) {
                setTimeout(function() {
                  CHILD_WINDOW_HANDLE.postMessage(popOutChat, "*")
                }, 500);
              }
              break;
            case "chatButtonClick":
              if (isMobileBrowser()) {
                _chatButtonFrame.contentWindow.postMessage({
                  messageType: "resize",
                  data: {
                    minimize: true,
                  },
                }, "*");
                win = window.open(_url, "_blank");
                win.focus();
              } else {
                _frame.contentWindow.postMessage({
                  messageType: "chatButtonClick",
                  data: md,
                }, "*");
              }
              break;
            case "messageCount":
              _chatButtonFrame.contentWindow.postMessage({
                messageType: "messageCount",
                data: md,
              }, "*");
              if (showBadge && {}.toString.call(showBadge) === "[object Function]") {
                showBadge(md.msgCount);
              }
              break;
            case "chatProfile":
              _chatButtonFrame.contentWindow.postMessage({
                messageType: "chatProfile",
                data: md,
              }, "*");
              position = md.chatProfile.chatButtonPosition.toLowerCase() === "bottomleft" ? "left" : "right";
              addCss(position);
              if (sessionParameter !== "undefined" && sessionParameter.length > 0) {
                _frame.contentWindow.postMessage({
                  messageType: "storeParameter",
                  data: sessionParameter,
                }, "*");
              }
              break;
            case "isChildWindowClosed":
              _frame.contentWindow.postMessage({
                messageType: "isChildWindowClosed",
                data: md,
              }, "*");
              break;
          }
        }
      } catch (err) {}
    }

    function setIpad() {
      if (/iPad/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
        isIpad = true;
      }
    }

    function getHeight(height) {
      if (height < minHeight) {
        height = minHeight;
      }
      if (height >= window.innerHeight) {
        height = window.innerHeight;
        document.getElementById("chat-div-wrap").style.maxHeight = height + "px";
      }
      return height;
    }

    function getWidth(width) {
      if (width < minWidth) {
        width = minWidth;
      }
      if (width >= window.innerWidth - windowScrollWidth) {
        width = window.innerWidth - windowScrollWidth;
      }
      return width;
    }

    function setXYPosition(left, top, width, height) {
      let xPosition;
      let yPosition;
      xMax = window.innerWidth - width - browserScrollWidth;
      yMax = window.innerHeight - height;
      if (left >= 0 && left <= xMax) {
        xPosition = left;
      } else if (left < 0) {
        xPosition = 0;
      } else if (xMax <= 0) {
        xPosition = 0;
      } else if (left > xMax) {
        xPosition = xMax;
      }
      if (top >= 0 && top <= yMax) {
        yPosition = top;
      } else if (top <= 0) {
        yPosition = 0;
      } else if (top > yMax) {
        yPosition = yMax;
      }
      document.getElementById("chat-div-wrap").style.left = xPosition + "px";
      document.getElementById("chat-div-wrap").style.top = yPosition + "px"
    }

    function showEmbed() {
      let wDiff;
      let hDiff;
      let ispopOutChat = sessionStorage.getItem("isPopOut") && sessionStorage.getItem("isPopOut") !== "true" ? false : true;
      if (customChatButton === true && _frame && !ispopOutChat) {
        if (isMobileBrowser()) {
          _chatButtonFrame.contentWindow.postMessage({
            messageType: "resize",
            data: {
              minimize: true,
            },
          }, "*");
          win = window.open(_url, "_blank");
          win.focus();
        } else {
          if ((customHeight && customWidth) !== null) {
            resizeChat(_frame, customHeight, customWidth)
          } else if ((customHeight || customWidth) === null) {
            wDiff = window.innerWidth - chatW;
            hDiff = window.innerHeight - chatH;
            leftPos = wDiff / 2;
            topPos = hDiff / 2;
            setXYPosition(leftPos, topPos, chatW, chatH);
            document.getElementById("chat-div-wrap").style.bottom = topPos + "px";
            resizeChat(_frame, chatH, chatW);
            document.getElementById("chat-div-wrap").style.width = chatW + "px";
            document.getElementById("chat-div-wrap").style.height = chatH + "px"
          }
          _frame.contentWindow.postMessage({
            messageType: "chatButtonClick",
            data: {
              minimize: false,
            },
          }, "*");
          document.getElementById("chat-div-wrap").style.width = _frame.width + "px";
          document.getElementById("chat-div-wrap").style.height = _frame.height + "px";
          if (showBadge && {}.toString.call(showBadge) === "[object Function]") {
            showBadge(0);
          }
        }
      } else {
        if ((customHeight || customWidth) !== null) {
          wDiff = window.innerWidth - customWidth;
          hDiff = window.innerHeight - customHeight;
          if (hDiff / 2 > topPos) {
            topPos = topPos
          } else if (hDiff / 2 === topPos) {
            topPos = hDiff
          } else if (hDiff / 2 < topPos) {
            topPos = hDiff
          }
          if (wDiff / 2 > leftPos) {
            leftPos = leftPos
          } else if (wDiff / 2 === leftPos) {
            leftPos = wDiff
          } else if (wDiff / 2 < leftPos) {
            leftPos = wDiff
          }
          setXYPosition(leftPos, topPos, customWidth, customHeight);
          document.getElementById("chat-div-wrap").style.top = topPos + "px";
          resizeChat(_frame, customHeight, customWidth);
          document.getElementById("chat-div-wrap").style.width = customWidth + "px";
          document.getElementById("chat-div-wrap").style.height = customHeight + "px";
          _frame.contentWindow.postMessage({
            messageType: "chatButtonClick",
            data: {
              minimize: false
            }
          }, "*");
          if (showBadge && {}.toString.call(showBadge) === "[object Function]") {
            showBadge(0)
          }
        } else {
          wDiff = window.innerWidth - chatW;
          hDiff = window.innerHeight - chatH;
          leftPos = wDiff / 2;
          topPos = hDiff / 2;
          setXYPosition(leftPos, topPos, chatW, chatH);
          document.getElementById("chat-div-wrap").style.bottom = topPos + "px";
          resizeChat(_frame, chatH, chatW);
          document.getElementById("chat-div-wrap").style.width = chatW + "px";
          document.getElementById("chat-div-wrap").style.height = chatH + "px";
          _frame.contentWindow.postMessage({
            messageType: "chatButtonClick",
            data: {
              minimize: false
            }
          }, "*");
          if (showBadge && {}.toString.call(showBadge) === "[object Function]") {
            showBadge(0)
          }
        }
      }
    }

    function windowDimensions(dimension) {
      if (dimension !== null) {
        windowConfig = dimension;
        dimension.left = isNaN(dimension.left) ? 10 : dimension.left;
        dimension.top = isNaN(dimension.top) ? 10 : dimension.top;
        customWidth = isNaN(dimension.width) ? chatW : dimension.width;
        customHeight = isNaN(dimension.height) ? chatH : dimension.height;
        leftPos = dimension.left;
        topPos = dimension.top;
        if (customChatButton === true) {
          if (_frame) {
            customHeight = getHeight(customHeight);
            customWidth = getWidth(customWidth);
            setXYPosition(dimension.left, dimension.top, customWidth, customHeight)
          }
        }
      }
    }

    function onResize(event) {
      const elementVal = document.getElementById("chat-div-wrap").style.width.replace("px", "");
      let width = parseInt(elementVal);
      if (width === NaN) {
        width = 0;
      }
      if (width > 0) {
        if (customChatButton === true && !isMobileBrowser()) {
          windowDimensions(windowConfig);
          showEmbed();
        }
      }
    }

    function addEventListener() {
      let eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      let eventer = window[eventMethod];
      let messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
      eventer(messageEvent, onMessageReceived, false);
      eventer("resize", onResize, false);
    }

    return {
      init: function(args, badgeRef) {
          let q = "";
          let opt = [];
          let i = 0;
          if (args.serverHost && args.bus_no && args.poc) {
            _host = args.serverHost;
            customChatButton = args.customChatButton ? true : false;
            opt = args.params ? args.params : [];
            for (i = 0; i < opt.length && i < 9; i++) {
              sessionParameter.push(opt[i]);
              q = q + "&P" + i + "=" + encodeURIComponent(opt[i])
            }
            if (!isMobileBrowser()) {
              _url = _host + "/inContact/ChatClient/ChatClient.aspx?poc=" + args.poc + "&bu=" + args.bus_no
            } else {
              _url = _host + "/inContact/ChatClient/ChatClient.aspx?poc=" + args.poc + "&bu=" + args.bus_no + q
            }
            setIpad();
            addEventListener();
            if (!sessionStorage.getItem("isPopOut")) {
              sessionStorage.setItem("isPopOut", "false")
            }
            addChatIframe(_url, _host);
            resizeChat(_frame, initialH, initialW);
            if (customChatButton === false) {
              resizeChat(_chatButtonFrame, chatButtonH, chatButtonW)
            } else {
              if (badgeRef && {}.toString.call(badgeRef) === "[object Function]") {
                  showBadge = badgeRef
              }
              resizeChat(_chatButtonFrame, initialH, initialW)
            }
            document.getElementById("chat-div-wrap").style.width = "0"
          }
      },
      setDimension: function(dimension) {
        windowDimensions(dimension)
      },
      hide: function() {
        if (customChatButton === true && _frame) {
          if (isMobileBrowser()) {
            _chatButtonFrame.contentWindow.postMessage({
              messageType: "resize",
              data: {
                minimize: true
              }
            }, "*");
            win = window.open(_url, "_blank");
            win.focus()
          } else {
            resizeChat(_frame, minH, minW);
            _frame.height = minH + "px";
            _frame.width = minW + "px";
            document.getElementById("chat-div-wrap").style.width = minW + "px";
            _frame.contentWindow.postMessage({
              messageType: "chatButtonClick",
              data: {
                minimize: true
              }
            }, "*")
          }
        }
      },
      show: function() {
        showEmbed()
      },
      setStateWindowToggle: function() {
        if (document.getElementById("chat-div-wrap").style.width > "0px") {
          this.hide()
        } else {
          if (CHILD_WINDOW_HANDLE !== null && CHILD_WINDOW_HANDLE.closed === true) {
            CHILD_WINDOW_HANDLE = null;
            _frame.contentWindow.postMessage({
              messageType: "isChildWindowClosed",
              data: {}
            }, "*");
            sessionStorage.setItem("isPopOut", "false");
            setTimeout(this.show, 1e3)
          } else {
            this.show()
          }
        }
      }
    }
  }
}

export const patronChat = new PatronChat();


// WEBPACK FOOTER //
// ./src/js/widgets/patron-chat-modal.js